/**
 * Converts a hexadecimal color code to an rgb() string.
 *
 * @param {string} hex - The hexadecimal color code.
 * @return {string} The corresponding RGB color value string, eg: "0, 217, 48".
 */
export const hexToRGB = (hex: string): string => {
  let alpha = false;
  let h: string | number = hex.slice(hex.startsWith('#') ? 1 : 0);

  if (h.length === 3) {
    h = [...h].map((x) => x + x).join('');
  } else if (h.length === 8) {
    alpha = true;
  }

  h = parseInt(h, 16);

  return `
    ${h >>> (alpha ? 24 : 16)}, 
    ${(h & (alpha ? 0x00ff0000 : 0x00ff00)) >>> (alpha ? 16 : 8)},
    ${(h & (alpha ? 0x0000ff00 : 0x0000ff)) >>> (alpha ? 8 : 0)}
  `;
};
